// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JQ0l","top":"styles_top__2QlUf","left":"styles_left__3x7g7","description":"styles_description__KM-LA"};